<a
    class="group relative flex justify-center items-center w-full h-full lg:h-screen"
    [attr.data-cy]="'section-card-' + data().text"
    routerLink="/{{ languageService.getLanguageCode }}/{{ link() }}"
>
    <img
        fetchpriority="high"
        [src]="domHandler.getSmallestImageAsWebp(data().image)"
        [srcset]="domHandler.generateSrcsetAsWebp(data().image)"
        alt="{{ data().image.alternativeText }} text-image"
        class="absolute size-full object-cover cursor-pointer select-none grow"
    />
    <div
        class="absolute opacity-90 group-hover:opacity-70 size-full transition-opacity cursor-pointer"
        [ngClass]="[isLeft() ? 'bg-white' : 'bg-primary']"
    ></div>
    <div
        class="flex items-center"
        [ngClass]="{ 'flex-row-reverse': !isLeft() }"
    >
        <img
            src="icons/arrow.svg"
            alt="arrow"
            class="z-10 cursor-pointer select-none ~size-14/16 transform"
            [ngClass]="[
                isLeft()
                    ? 'group-hover:animate-scroll-left'
                    : 'group-hover:animate-scroll-right rotate-180',
            ]"
        />
        <p
            animate
            class="group-hover:bg-black p-4 font-bold lg:group-hover:text-[3.5rem] text-nowrap transition-[colors,font] cursor-pointer ~text-3xl/5xl transform"
            [ngClass]="[isLeft() ? 'text-primary' : 'text-white']"
            style="clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%)"
        >
            <span class="select-none">
                {{ data().text }}
            </span>
        </p>
    </div>
</a>
